import { Link } from 'react-router-dom';
import './LogoMark.css';

export function LogoMark({ variant = 'hero' }) {
  const isSidebar = variant === 'sidebar';
  const isHeader = variant === 'header';

  const imgSizes =
    variant === 'sidebar'
      ? { width: 512, height: 512 }
      : variant === 'header'
        ? { width: 280, height: 56 }
        : { width: 240, height: 240 };

  const img = (
    <div className={`logo-mark logo-mark--${variant}`}>
      <img
        className="logo-mark__img"
        src={`${process.env.PUBLIC_URL}/logo-small.png`}
        alt="Shops.mt"
        {...imgSizes}
      />
    </div>
  );

  if (isSidebar || isHeader) {
    return (
      <Link
        to="/"
        className={`logo-mark__link${isHeader ? ' logo-mark__link--header' : ''}`}
        title="Shops.mt — home"
      >
        {img}
      </Link>
    );
  }

  return img;
}
